// extracted by mini-css-extract-plugin
export default {"AwesomeInput":"AwesomeInput_AwesomeInput__99MbM","SearchResult":"AwesomeInput_SearchResult__vSXWf","HomeIcon":"AwesomeInput_HomeIcon__dFloC"};